import { browserTracker } from "../lib/analytics";

// レイアウトが測定 ID を出力しているページでのみ読み込まれる。
// CSP が script-src 'self' のため、インラインスニペットではなくこのファイルで初期化する
browserTracker().startPageTracking();
